var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowsCircle32Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E637CF6E-3AA3-410C-91EE-02A840A00713_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 C32,24.8365565 24.8365565,32 16,32 C7.16344348,32 0,24.8365565 0,16 C0,7.16344348 7.16344348,0 16,0 C24.8365565,0 32,7.16344348 32,16 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Krediitkaart",
    transform: "translate(-1009.000000, -199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(208.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(801.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Arrows-Circle_32px",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stroke-1",
    fill: "#E7E7E7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    mask: "url(#mask-2)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5263158,9.47368421 L24,0",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,24 L9.47368421,14.5263158",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    points: "23.3684211 9.47368421 14.5263158 9.47368421 14.5263158 0.631578947"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "9.47368421 23.3684211 9.47368421 14.5263158 0.631578947 14.5263158"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsCircle32Px);
export default __webpack_public_path__ + "static/media/Icon_Arrows-Circle_32px.06146f02114cb1c4fa3090d75c4494f1.svg";
export { ForwardRef as ReactComponent };